<template>
  <login-panel class="software-license-text">
    <h3
      class="software-license-text__title"
      slot="login-panel-header"
    >
      {{ $t('login.software-license') }}
    </h3>
    <loading v-if="loading"
      class="software-license-text__loading"
    />
    <div
      v-if="!loading"
      class="software-license-text__content"
      v-html="licenseContent">
    </div>
    <div
      class="software-license-text__footer"
      slot="login-panel-footer"
    >
      <router-link
        :to="{ name: 'software-license-confirmation' }"
        id="next"
      >
        <b-button
          :disabled="!licenseContent"
          variant="primary"
          class="software-license-text__next-btn"
        >{{ $t('general.next') }}</b-button>
      </router-link>
    </div>
  </login-panel>
</template>

<script>
import LoginPanel from '@/components/LoginPanel';
import Loading from '@/components/Loading';
import SoftwareLicenseService from '@/domain/services/generalPanel/softwareLicense';

export default {
  components: {
    LoginPanel,
    Loading,
  },
  data() {
    return {
      loading: false,
      licenseContent: null,
    };
  },
  created() {
    this.getLicense();
  },
  methods: {
    getLicense() {
      this.loading = true;
      SoftwareLicenseService.getLicense().then((response) => {
        this.licenseContent = response;
      }).finally(() => {
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.software-license-text
  &__title
    font-size: 1.1rem
    font-weight: 600
    text-transform: uppercase
  &__loading
    flex: 1
    font-size: 1.5em
  &__next-btn
    float: right
    font-weight: 600
    padding-left: 30px
    padding-right: 30px
</style>
